export const COMMANDE_ENREGISTRER = 'Commande/COMMANDE_ENREGISTRER';
export const COMMANDE_RECHERCHER = 'Commande/COMMANDE_RECHERCHER';
export const LIRE_COMMANDE = 'Commande/LIRE_COMMANDE';
export const CHANGE_CLOSE_POPUP = 'Commande/CHANGE_CLOSE_POPUP';

export const SAVE_FILTER = 'Commande/SAVE_FILTER';

export const defaultFiltre = {};
